import { render, staticRenderFns } from "./screen.vue?vue&type=template&id=a8c1e4fa"
import script from "./screen.vue?vue&type=script&lang=js"
export * from "./screen.vue?vue&type=script&lang=js"
import style0 from "./screen.vue?vue&type=style&index=0&id=a8c1e4fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports